var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('b-btn',{staticClass:"mt-4",attrs:{"variant":"main","size":"lg","block":""},on:{"click":_vm.save}},[_vm._v(" Continuar "),_c('i',{staticClass:"bi bi-chevron-left"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }